import { useSnackbar } from "notistack";
import { getInvoicePdf } from "../../../api/api";

// Long enough for the new tab to load the PDF; revoking right away would pull it out from under the tab.
const OBJECT_URL_LIFETIME_MS = 60_000;

/**
 * Opens an invoice PDF in a new tab. The API serves it only to authenticated requests, so a plain link can't open
 * it: the PDF is fetched here and shown from an object URL. The tab is opened before the fetch, while the click still
 * counts as a user gesture, so popup blockers let it through.
 */
export const useOpenInvoicePdf = () => {
  const { enqueueSnackbar } = useSnackbar();

  return async (pdfUrl: string) => {
    const tab = window.open("", "_blank");
    try {
      const objectUrl = URL.createObjectURL(await getInvoicePdf(pdfUrl));
      if (tab) {
        tab.location.href = objectUrl;
      } else {
        window.open(objectUrl, "_blank");
      }
      setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_LIFETIME_MS);
    } catch (error) {
      tab?.close();
      enqueueSnackbar(`Nie udało się otworzyć faktury. Powód: ${(error as Error).message}`, { variant: "error" });
    }
  };
};
